<div
  *ngIf="{
    userProfile: userProfile$ | async,
    isAllSurveyComplete: isAllSurveyComplete$ | async,
    isCareerGoalSet: isCareerGoalSet$ | async,
    isEnableToDownload: isEnableToDownload$ | async,
    isAcademicInstitutionProgramGoalSet:
      isAcademicInstitutionProgramGoalSet$ | async,
    reportShared: reportShared$ | async,
    goals: goals$ | async,
    returnLink: returnLink$ | async,
    news: news$ | async
  } as data"
  class="tutorial"
>
  <div class="tutorial__header">
    <button
      aria-label="Close tutorial"
      type="button"
      class="close-button"
      mat-icon-button
      [mat-dialog-close]="true"
    >
      <mat-icon class="close-icon" svgIcon="close"></mat-icon>
    </button>

    <ng-container *ngIf="!!selectedNews">
      <fa-icon
        class="back"
        (click)="selectedNews = null"
        [icon]="['fas', 'chevron-left']"
      ></fa-icon>
    </ng-container>
    <ng-container *ngIf="!selectedNews">
      <div class="title">
        {{ selectedTab === 'tutorial' ? 'Tutorial' : 'News' }}
      </div>
      <div *ngIf="selectedTab === 'tutorial'" class="steps-progress">
        <mat-progress-bar
    aria-label="Loading results"
          class="step"
          color="primary"
          mode="determinate"
          [value]="25 * surveyCompletion"
        ></mat-progress-bar>
        <div class="step" [ngClass]="{ done: data.isCareerGoalSet }"></div>
        <div
          class="step"
          [ngClass]="{ done: data.isAcademicInstitutionProgramGoalSet }"
        ></div>
        <div class="step" [ngClass]="{ done: data.reportShared }"></div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="!!selectedNews">
    <div class="news-details__body">
      <cpd-news-card
        [news]="selectedNews"
        [isFull]="true"
        (react)="onReactOnNews(selectedNews, $event)"
      ></cpd-news-card></div
  ></ng-container>

  <ng-container *ngIf="!selectedNews">
    <div [class]="selectedTab === 'news' ? 'news__body' : 'tutorial__body'">
      <div *ngIf="selectedTab === 'tutorial'" class="tab__content">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="step__title">
                <img alt=""
                  *ngIf="data.isAllSurveyComplete"
                  src="assets/images/icons/check-circle.svg"
                />
                <img alt=""
                  *ngIf="!data.isAllSurveyComplete"
                  src="assets/images/icons/uncheck-circle.svg"
                />
                Take Your Surveys
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="step__description">
              <p>
                Take the skills, lifestyle, interests, and values surveys on the
                Build Your Target tab in order to get personalized results to
                appear in the career scrollers.
              </p>
              <cpd-flat-button
                color="primary"
                text="Take Me To Surveys"
                (click)="goToTheSurveys()"
              >
              </cpd-flat-button>
              <cpd-stroked-button
                (click)="openGuidDialog('Take Your Surveys')"
                color="primary"
                fontIcon="play"
                fontSet="fal"
                text="See How It Works"
              ></cpd-stroked-button>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="step__title">
                <img alt=""
                  *ngIf="data.isCareerGoalSet"
                  src="assets/images/icons/check-circle.svg"
                />
                <img alt=""
                  *ngIf="!data.isCareerGoalSet"
                  src="assets/images/icons/uncheck-circle.svg"
                />
                Set Your Career Goal
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="step__description">
              <p>
                Explore career cards within the scrollers on the Build Your
                Target page.
              </p>
              <p>
                Click on careers that interest you to review career details such
                as the skills, education requirements and where they're in
                demand in the US.
              </p>
              <p>
                Click the ‘Set Career Goal’ button at the top of a career page
                in order to set your career goal.
              </p>
              <p>
                If you do not want to set the career as a goal you can favorite
                the career using the bookmark button and come back to it later.
              </p>
              <cpd-flat-button
                (click)="goToCareersScroller()"
                color="primary"
                text="Take Me To Careers"
              >
              </cpd-flat-button>
              <cpd-stroked-button
                (click)="openGuidDialog('Set Your Career Goal')"
                color="primary"
                fontIcon="play"
                fontSet="fal"
                text="See How It Works"
              ></cpd-stroked-button>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="step__title">
                <img alt=""
                  *ngIf="data.isAcademicInstitutionProgramGoalSet"
                  src="assets/images/icons/check-circle.svg"
                />
                <img alt=""
                  *ngIf="!data.isAcademicInstitutionProgramGoalSet"
                  src="assets/images/icons/uncheck-circle.svg"
                />
                Set Your Academic Goal
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="step__description">
              <p class="highlight">
                Note: Academic goals are optional and are not required. If you
                are unsure of an academic goal reach out to your counselor as a
                key resource for guidance.
              </p>
              <p>
                Review the level of education required for your career goal.
              </p>
              <p>
                Explore institutions where you can use your TA benefits using
                the institution table at the bottom the career page.
              </p>
              <p>
                Click on an institution to see available programs and
                institution details.
              </p>
              <p>
                Click the ‘Set Goal’ button next to the program you would like
                to pursue in order to set your academic goal.
              </p>
              <cpd-flat-button
                [disabled]="!data.isCareerGoalSet"
                [matTooltipDisabled]="data.isCareerGoalSet"
                [matTooltipPosition]="'above'"
                [matTooltip]="
                  'Set a career goal to view institutions that align with that career.'
                "
                color="primary"
                text="Take Me To Institutions"
                (click)="
                  data.isCareerGoalSet && goToInstitutions(data.goals.onetCode)
                "
              >
              </cpd-flat-button>
              <cpd-stroked-button
                (click)="openGuidDialog('Set Your Academic Goal')"
                color="primary"
                fontIcon="play"
                fontSet="fal"
                text="See How It Works"
              ></cpd-stroked-button>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="step__title">
                <img alt=""
                  *ngIf="data.reportShared"
                  src="assets/images/icons/check-circle.svg"
                />
                <img alt=""
                  *ngIf="!data.reportShared"
                  src="assets/images/icons/uncheck-circle.svg"
                />
                Save Your Return Link
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="step__description">
              <p>
                Copy or email your Return Link to yourself so you can come back
                to your Goals Report. You can copy the link from the Goals
                Report page or use the 'Save Session' button at the top of the
                page. Your Return Link signs you in, so keep it to yourself.
              </p>
              <p>
                To get guidance on your next steps toward your career and
                academic goals, use Share with your counselor on your Goals
                Report. That gives your education counselor a separate link to
                read the report.
              </p>
              <div>
                <cpd-flat-button
                  color="primary"
                  [disabled]="!data.returnLink"
                  type="button"
                  [text]="'Copy Return Link'"
                  (click)="
                    data.isAllSurveyComplete &&
                      (data.isCareerGoalSet || data.isAcademicGoalSet) &&
                      copy(data.returnLink, tooltip)
                  "
                >
                </cpd-flat-button>
                <span
                  class="tooltip-point"
                  #tooltip="matTooltip"
                  matTooltip="Link Copied!"
                  matTooltipShowDelay="200"
                  matTooltipClass="green"
                  matTooltipPosition="above"
                ></span>
              </div>
              <cpd-stroked-button
                (click)="openGuidDialog('Save Your Return Link')"
                fontIcon="play"
                fontSet="fal"
                color="primary"
                text="See How It Works"
              ></cpd-stroked-button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div *ngIf="selectedTab === 'news'" class="tab__content">
        <cpd-news-card
          *ngFor="let news of data.news"
          [news]="news"
          (react)="onReactOnNews(news, $event)"
          (view)="selectedNews = $event"
          class="mb-4 block"
        ></cpd-news-card>
      </div>
    </div>

    <div class="tutorial__footer">
      <div
        role="button"
        tabindex="0"
        (keydown.enter)="selectedTab = 'tutorial'"
        (keydown.space)="$event.preventDefault(); selectedTab = 'tutorial'"
        class="tab"
        (click)="selectedTab = 'tutorial'"
        [ngClass]="{ active: selectedTab === 'tutorial' }"
      >
        <div class="tab__icon">
          <img alt=""
            src="assets/images/tutorial/play-tutorial{{
              selectedTab === 'tutorial' ? '-filled' : ''
            }}.svg"
          />
        </div>
        <div class="tab__label">Tutorial</div>
      </div>
      <div
        role="button"
        tabindex="0"
        (keydown.enter)="selectedTab = 'news'"
        (keydown.space)="$event.preventDefault(); selectedTab = 'news'"
        class="tab"
        (click)="selectedTab = 'news'"
        [ngClass]="{ active: selectedTab === 'news' }"
      >
        <div class="tab__icon">
          <img alt=""
            src="assets/images/tutorial/news{{
              selectedTab === 'news' ? '-filled' : ''
            }}.svg"
          />
        </div>
        <div class="tab__label">News</div>
      </div>
    </div>
  </ng-container>
</div>
